var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0.182373C6.86679 -0.0609459 7.29922 -0.0609456 7.60352 0.182373L13.8535 5.18237C14.0512 5.34052 14.166 5.58059 14.166 5.83374V15.8337L14.1621 15.9187C14.1194 16.3388 13.7644 16.6667 13.333 16.6667H0.833008C0.401594 16.6667 0.0466606 16.3388 0.00390625 15.9187L0 15.8337V5.83374C0 5.58059 0.114821 5.34052 0.3125 5.18237L6.5625 0.182373ZM1.66602 6.23413V14.9998H4.16602V10.4167C4.16602 9.95651 4.53976 9.58374 5 9.58374H9.16602C9.62625 9.58374 10 9.95651 10 10.4167V14.9998H12.5V6.23413L7.08301 1.90015L1.66602 6.23413ZM5.83301 14.9998H8.33301V11.2498H5.83301V14.9998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d9ad98be8891d1d7a4fcc8591d4d19db.svg";
export { ForwardRef as ReactComponent };